angular.module('am4').directive('elasticList', function() {
    return {
        restrict: 'E',
        template: require('./elasticList.html')
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/elasticList.js